import React from 'react';
import { ControlLink } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { LineItemType } from '../lineItemMutations.rest';
import './LineItemActions.scss';

type Props = {
  item: LineItem;
  onDelete: () => void;
  onChangeType: (type: LineItemType) => void;
};

export const LineItemActions: React.FC<Props> = ({ item, onDelete, onChangeType }) => {
  return (
    <div className="LineItemActions">
      {item.type === 'cart_items' && (
        <ControlLink onClick={() => onChangeType('SavedItem')} data-testid="saveForLater">
          Save for later
        </ControlLink>
      )}
      {item.type === 'saved_items' && (
        <ControlLink onClick={() => onChangeType('CartItem')} data-testid="moveToBag">
          Move to bag
        </ControlLink>
      )}
      <ControlLink onClick={onDelete}>Remove</ControlLink>
    </div>
  );
};
